import axios from "axios";
import { useEffect, useState } from "react";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const NilaiRaporList = ({ mapel }) => {
  const [nilaiFinal, setNilaiFinal] = useState([]);
  const [tahun, setTahun] = useState("");
  const [semester, setSemester] = useState("");
  const [kelas, setKelas] = useState("");
  const [rombel, setRombel] = useState("");
  const [tp, setTP] = useState([]);
  const [terbaikTerendah, setTerbaikTerendah] = useState([]);

  const prosesCPTerbaikDanTerendah = (data, dataTP) => {
    return data.map((siswa) => {
      const nilaiPerTP = siswa.nilaiPerTP || {};

      let CPterbaik = { nomor: "", rata2: -Infinity, isiTP: "" };
      let CPterendah = { nomor: "", rata2: Infinity, isiTP: "" };

      for (const cp in nilaiPerTP) {
        let rata2;
        const nilai = nilaiPerTP[cp];

        // ✅ JIKA ARRAY
        if (Array.isArray(nilai) && nilai.length > 0) {
          const total = nilai.reduce((s, n) => s + n, 0);
          rata2 = total / nilai.length;
        }
        // ✅ JIKA ANGKA
        else if (typeof nilai === "number") {
          rata2 = nilai;
        }
        // ❌ TIDAK VALID
        else {
          continue;
        }

        const isiTP = dataTP[0]?.TP.find((tp) => tp.nomor === cp)?.isiTP || "";

        if (rata2 > CPterbaik.rata2) {
          CPterbaik = { nomor: cp, rata2, isiTP };
        }

        if (rata2 < CPterendah.rata2) {
          CPterendah = { nomor: cp, rata2, isiTP };
        }
      }

      return {
        studentId: siswa.studentId,
        name: siswa.name,
        CPterbaik,
        CPterendah,
      };
    });
  };

  useEffect(() => {
    const fetchNilaiFinal = async () => {
      if (!mapel || !kelas || !semester || !tahun || !rombel) return;

      try {
        const token = localStorage.getItem("token");
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}api/nilaiFinal/mapel/${mapel}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          },
        );

        // 🔥 FILTER DI FRONTEND
        const filtered = response.data.filter((item) => {
          return (
            item.tahun === tahun &&
            item.semester === semester &&
            String(item.kelas) === String(kelas) &&
            item.rombel === rombel
          );
        });

        setNilaiFinal(filtered);
      } catch (error) {
        console.error("Error fetching NilaiFinal:", error);
        toast.error("Gagal mengambil data Nilai Final!");
        setNilaiFinal([]);
      }
    };

    const fetchTPAndCP = async () => {
      if (!mapel || !kelas || !rombel || !semester || !tahun) return;

      try {
        const token = localStorage.getItem("token");

        // 1. Fetch TP terlebih dahulu
        const responseTP = await axios.get(
          `${process.env.REACT_APP_API_URL}api/tp/mapel/${mapel}`,
          {
            headers: { Authorization: `Bearer ${token}` },
            params: { semester, kelas },
          },
        );
        setTP(responseTP.data);

        // 2. Fetch CP terbaik & terendah
        const responseCP = await axios.get(
          `${process.env.REACT_APP_API_URL}api/nilai/cp-terbaik-kurang/mapel/${mapel}/kelas/${kelas}/rombel/${rombel}/tahun/${tahun}/semester/${semester}`,
          { headers: { Authorization: `Bearer ${token}` } },
        );

        // baru gunakan dataTP dari responseTP
        const hasil = prosesCPTerbaikDanTerendah(
          responseCP.data,
          responseTP.data,
        );
        setTerbaikTerendah(hasil);
      } catch (error) {
        console.error(error);
      }
    };

    fetchTPAndCP();

    fetchNilaiFinal();
  }, [mapel, tahun, semester, kelas, rombel]);

  const buildPayloadNilaiRapor = () => {
    return {
      mapel,
      kelas,
      rombel,
      tahun,
      semester,
      nilai: terbaikTerendah.map((item) => {
        const nilaiAkhir = nilaiFinal
          .flatMap((nf) => nf.nilai)
          .find(
            (n) => n.studentId?._id?.toString() === item.studentId?.toString(),
          );

        return {
          studentId: item.studentId,
          name: item.name,

          // ✅ nilai akhir dari nilaiFinal
          finalScore: nilaiAkhir?.finalScore ?? 0,

          // ✅ CP terbaik → CP tercapai
          CPtercapi: item.CPterbaik?.isiTP ? [item.CPterbaik.isiTP] : [],

          // ✅ CP terendah → CP ditingkatkan
          CPditingkatkan: item.CPterendah?.isiTP ? [item.CPterendah.isiTP] : [],
        };
      }),
    };
  };

  const handleSimpanNilaiRapor = async () => {
    try {
      const token = localStorage.getItem("token");
      const payload = buildPayloadNilaiRapor();

      await axios.post(
        `${process.env.REACT_APP_API_URL}api/nilaiRapor`,
        payload,
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );

      toast.success("Nilai rapor berhasil disimpan!");
    } catch (error) {
      console.error(error);
      toast.error("Gagal menyimpan nilai rapor!");
    }
  };

  const handleReplaceNilaiRapor = async () => {
    const payload = buildPayloadNilaiRapor();

    // console.log("DEBUG PAYLOAD REPLACE:", {
    //   mapel,
    //   kelas,
    //   rombel,
    //   tahun,
    //   semester,
    //   nilaiLength: payload.nilai.length,
    //   payload,
    // });

    if (
      !mapel ||
      !kelas ||
      !rombel ||
      !tahun ||
      !semester ||
      payload.nilai.length === 0
    ) {
      toast.error("Filter atau data nilai belum lengkap!");
      return;
    }

    try {
      const token = localStorage.getItem("token");

      await axios.put(
        `${process.env.REACT_APP_API_URL}api/nilaiRapor/replace`,
        payload,
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );

      toast.success("Nilai rapor berhasil diperbarui!");
    } catch (error) {
      console.error(error.response?.data || error);
      toast.error("Gagal update nilai rapor!");
    }
  };

  return (
    <div className="bg-white my-10 rounded-lg p-5 drop-shadow-lg w-auto mx-8">
      <ToastContainer />
      <div className="flex justify-center">
        <h2 className="font-bold text-2xl">Daftar Nilai Rapor</h2>
      </div>

      {/* Filter */}
      <div className="grid gap-4 border border-slate-500 p-4 rounded-lg bg-white shadow-md my-5">
        <div className="flex items-center gap-3">
          <label className="w-1/3 font-medium">Tahun:</label>
          <input
            type="text"
            value={tahun}
            onChange={(e) => setTahun(e.target.value)}
            className="flex-1 border border-slate-500 rounded-lg px-3 py-2"
          />
        </div>
        <div className="flex items-center gap-3">
          <label className="w-1/3 font-medium">Semester:</label>
          <select
            value={semester}
            onChange={(e) => setSemester(e.target.value)}
            className="flex-1 border border-slate-500 rounded-lg px-3 py-2"
          >
            <option value="">Pilih Semester</option>
            <option value="1">1</option>
            <option value="2">2</option>
          </select>
        </div>
        <div className="flex items-center gap-3">
          <label className="w-1/3 font-medium">Kelas:</label>
          <select
            value={kelas}
            onChange={(e) => setKelas(e.target.value)}
            className="flex-1 border border-slate-500 rounded-lg px-3 py-2"
          >
            <option value="">Pilih Kelas</option>
            {[1, 2, 3, 4, 5, 6].map((k) => (
              <option key={k} value={k}>
                {k}
              </option>
            ))}
          </select>
        </div>
        <div className="flex items-center gap-3">
          <label className="w-1/3 font-medium">Rombel:</label>
          <select
            value={rombel}
            onChange={(e) => setRombel(e.target.value)}
            className="flex-1 border border-slate-500 rounded-lg px-3 py-2"
          >
            <option value="">Pilih Rombel</option>
            <option value="A">A</option>
            <option value="B">B</option>
            <option value="C">C</option>
            <option value="D">D</option>
          </select>
        </div>
      </div>

      {/* Tabel Nilai Rapor */}
      <div className="overflow-x-auto max-h-[500px] overflow-y-auto max-y-[400px]">
        {!tahun || !semester || !kelas || !rombel ? (
          <p className="text-center">Silakan pilih filter terlebih dahulu.</p>
        ) : nilaiFinal.length > 0 ? (
          <div className="min-w-full border border-slate-400">
            <table className="w-full border-collapse border mt-6 text-sm">
              <thead>
                <tr className="bg-gray-100">
                  <th className="p-2 border">Nama Siswa</th>
                  <th className="p-2 border">Nilai Akhir</th>

                  <th className="p-2 border">TP yang terpenuhi</th>
                  <th className="p-2 border">TP perlu peningkatan</th>
                </tr>
              </thead>
              <tbody>
                {terbaikTerendah.map((item) => {
                  const nilaiAkhir = nilaiFinal
                    .flatMap((nf) => nf.nilai)
                    .find(
                      (n) =>
                        n.studentId?._id?.toString() ===
                        item.studentId?.toString(),
                    );

                  return (
                    <tr key={item.studentId} className="border-b align-top">
                      {/* Nama */}
                      <td className="p-2 border font-semibold">{item.name}</td>

                      {/* Nilai Akhir */}
                      <td className="p-2 border text-center font-bold">
                        {nilaiAkhir?.finalScore ?? "-"}
                      </td>
                      <td className="p-2 border text-justify">
                        {item.CPterbaik?.isiTP || "-"}
                      </td>
                      <td className="p-2 border text-justify">
                        {item.CPterendah?.isiTP || "-"}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
            <div className="flex justify-end gap-3 my-4 mx-5">
              <button
                onClick={handleSimpanNilaiRapor}
                className="bg-green-600 hover:bg-green-700 text-white px-5 py-2 rounded-lg font-semibold"
              >
                Simpan Baru
              </button>

              <button
                onClick={handleReplaceNilaiRapor}
                className="bg-blue-600 hover:bg-blue-700 text-white px-5 py-2 rounded-lg font-semibold"
              >
                Update / Replace
              </button>
            </div>
          </div>
        ) : (
          <p className="text-center">Tidak ada data yang ditemukan.</p>
        )}
      </div>
    </div>
  );
};

export default NilaiRaporList;
